import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { UNLINK_CLIENT_PROFILE, LOAD_TIMELINE } from "@Broker/@Modules/clients/board/store/board-actions";
import { TOGGLE_STARRED_APPLICATION } from "@Broker/@Modules/clients/board/store/board-mutations";
import LinkedApplicationItem from "./linked-application-item.vue";
import { orderBy } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LinkedApplicationsInfo",
  components: {
    InlinePrompt,
    LinkedApplicationItem
  },
  props: {
    applications: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    username: {
      type: String,
      default: ""
    },
    profile: {
      type: Object,
      required: true
    },
    hasApplications: {
      type: Boolean
    }
  },
  data() {
    return {
      unlinking: false,
      deletingApplication: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    sortedApplications() {
      return orderBy(this.applications, ["createdAt"], ["desc"]);
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("BoardStore", [UNLINK_CLIENT_PROFILE, LOAD_TIMELINE])), mapMutations("BoardStore", [TOGGLE_STARRED_APPLICATION])), {}, {
    last(index) {
      return index !== _Object$keys(this.applications).length - 1;
    },
    handleSave() {
      this.$emit("save");
    },
    handleCreate() {
      this.$emit("create");
    },
    async unlinkApplications() {
      this.unlinking = true;
      await this.UNLINK_CLIENT_PROFILE({
        clientProfileId: this.clientProfileId,
        accountUsername: null
      });
      this.TOGGLE_STARRED_APPLICATION({
        clientProfileId: this.clientProfileId
      });
      await this.LOAD_TIMELINE({
        id: this.clientProfileId,
        limit: 20,
        offset: 0
      });
      this.unlinking = false;
    },
    setDuplicateModalData(applicationId) {
      this.$emit("duplicate-modal-opened", {
        pin: true,
        applicationId
      });
    },
    handleCopyApplication(application) {
      this.$emit("copy-application", application);
    }
  })
});